export interface OrderStatusMeta {
  label: string;
  tuiStatus: 'neutral' | 'success' | 'error' | 'warning';
  cssClass: string;
}

export const STATUS_CODE_MAP: Record<number, keyof typeof ORDER_STATUS_MAP> = {
  0: 'INITIALIZED',
  1: 'PENDING',
  2: 'CONFIRMED',
  3: 'PICKING_UP',
  4: 'IN_PROGRESS',
  5: 'DELIVERING',
  6: 'FINISHED',
  7: 'FAILED',
  10: 'CANCELLED_BY_CAFLER',
  11: 'CANCELLED_BY_CLIENT',
  12: 'CANCELLED'
};

export const ORDER_STATUS_MAP: Record<string, OrderStatusMeta> = {
  INITIALIZED: { label: 'Inicializado', tuiStatus: 'neutral', cssClass: 'custom_initialized' },
  PENDING:     { label: 'Pendiente', tuiStatus: 'neutral', cssClass: 'custom_pending' },
  CONFIRMED:   { label: 'Confirmado', tuiStatus: 'success', cssClass: 'custom_confirmed' },
  PICKING_UP:  { label: 'Recogiendo', tuiStatus: 'warning', cssClass: 'custom_picking' },
  IN_PROGRESS: { label: 'En progreso', tuiStatus: 'warning', cssClass: 'custom_progress' },
  DELIVERING:  { label: 'Entregando', tuiStatus: 'warning', cssClass: 'custom_delivering' },
  FINISHED:    { label: 'Finalizado', tuiStatus: 'success', cssClass: 'custom_finished' },
  FAILED:      { label: 'Fallido', tuiStatus: 'error', cssClass: 'custom_failed' },
  CANCELLED_BY_CAFLER: { label: 'Cancelado por Cafler', tuiStatus: 'error', cssClass: 'custom_cancel_cafler' },
  CANCELLED_BY_CLIENT: { label: 'Cancelado por el cliente', tuiStatus: 'error', cssClass: 'custom_cancel_client' },
  CANCELLED:  { label: 'Cancelado', tuiStatus: 'error', cssClass: 'custom_cancelled' },
};
